import { useQuery } from "@tanstack/react-query";
import { shallowEqual, useSelector } from "react-redux";
import { BOOTSTRAP_INFO, BOOTSTRAP_INFO_URL } from "../constants";
import { useApiRequest } from "../../../system/hooks/useApiRequest";
import { isLoggedIn } from "../../../system/helpers/helpfulFunctions";
import { ApplicationState } from "../../../system/reducers";

export const useGetBootstrapInfo = () => {
  const { apiRequest } = useApiRequest();
  const { sso_token } = useSelector(
    (state: ApplicationState) => state.auth,
    shallowEqual,
  );

  return useQuery({
    queryKey: [BOOTSTRAP_INFO],
    queryFn: () =>
      apiRequest({
        type: "GET_BOOTSTRAP_INFO",
        request: {
          url: BOOTSTRAP_INFO_URL,
          method: "GET",
        },
      }),
    enabled: !!sso_token || isLoggedIn(),
    staleTime: 10 * 60 * 1000,
  });
};
